import { render } from "./social_chat.vue?vue&type=template&id=c2bad800&scoped=true"
import script from "./social_chat.vue?vue&type=script&lang=js"
export * from "./social_chat.vue?vue&type=script&lang=js"

import "./social_chat.vue?vue&type=style&index=0&id=c2bad800&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2bad800"]])

export default __exports__